// import { Button, Flex } from "@radix-ui/themes";
// import React from "react";

// export interface PaginationProps  {
//     total: number,
//     count: number,
//     activeIndex: number,
//     onChangeIndex: (index: number) => any,
//     classNameContainer?: string
// }


// export default function Pagination(props: PaginationProps) {
//     const {total, count, activeIndex, onChangeIndex, classNameContainer} = props
//     const pages = Math.ceil(total / count);
//     const arr = Array.from({ length: pages }, (_, i) => i + 1);
//     const changeIndex = (index: number) => {
//         onChangeIndex(index)
//     }
//     return (
//         <Flex gap={'1'} className={classNameContainer} wrap={'wrap'}>
//             {arr.map(item => {
//                 return <Button onClick={() => changeIndex(item - 1)} variant={activeIndex === item - 1 ? 'solid' : 'outline'}>
//                     {item}
//                 </Button>
//             })}
//         </Flex>
//     )
// }

import { Button, Flex } from "@radix-ui/themes";
import React from "react";

export interface PaginationProps {
  total: number;
  count: number;
  activeIndex: number;
  onChangeIndex: (index: number) => any;
  classNameContainer?: string;
}

export default function Pagination({
  total,
  count,
  activeIndex,
  onChangeIndex,
  classNameContainer,
}: PaginationProps) {
  const pages = Math.ceil(total / count);

  const changeIndex = (index: number) => {
    if (index >= 0 && index < pages) onChangeIndex(index);
  };

  // Определяем диапазон видимых страниц
  const getVisiblePages = () => {
    const visible: number[] = [];
    const maxVisible = 5;
    const start = Math.max(0, activeIndex - 2);
    const end = Math.min(pages - 1, start + maxVisible - 1);

    // Добавляем первую страницу, если её нет в диапазоне
    if (start > 0) {
      visible.push(0);
      if (start > 1) visible.push(-1); // маркер для "..."
    }

    // Основной диапазон страниц
    for (let i = start; i <= end; i++) visible.push(i);

    // Добавляем последнюю страницу, если её нет в диапазоне
    if (end < pages - 1) {
      if (end < pages - 2) visible.push(-1); // маркер для "..."
      visible.push(pages - 1);
    }

    return visible;
  };

  const visiblePages = getVisiblePages();

  return (
    <Flex gap="1" className={classNameContainer} wrap="wrap">
      {visiblePages.map((page, i) =>
        page === -1 ? (
          <Button key={`dots-${i}`} variant="ghost" disabled>
            ...
          </Button>
        ) : (
          <Button
            key={page}
            onClick={() => changeIndex(page)}
            variant={activeIndex === page ? "solid" : "outline"}
          >
            {page + 1}
          </Button>
        )
      )}
    </Flex>
  );
}